/**
 * Where each import module's jobs are viewed.
 *
 * The Imports audit log (`/leads/imports`) lists jobs across EVERY module, but a
 * job can only be read on its own module's page: a multi-sheet hotel import
 * rendered through the single-sheet lead page shows an empty row body, because
 * that page has no columns for the hotel sheets. So the audit log routes each
 * job by its `moduleKey` here rather than sending them all to the lead route.
 *
 * A module with no dedicated route falls back to the lead importer, which
 * renders any single-sheet module from its descriptor.
 */
const IMPORT_MODULE_ROUTE_PREFIX: Record<string, string> = {
  lead: 'leads',
  hotel: 'hotels',
  cruise: 'cruises',
  activity: 'activities',
  transfer: 'transfers',
  visa: 'visas',
  insurance: 'insurance',
  'meal-service': 'meal-services',
};

/** The path that renders a given import job, chosen by its module. */
export function importJobPath(moduleKey: string, jobId: string): string {
  const prefix = IMPORT_MODULE_ROUTE_PREFIX[moduleKey] ?? 'leads';
  return `/${prefix}/imports/jobs/${jobId}`;
}
